module.exports = __webpack_public_path__ + "static/media/beijing.8663091b.jpg";